module.exports = __webpack_public_path__ + "static/img/home1.e4be9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home1.png
// module id = 9UFW
// module chunks = 1